import { Box, Grid, IconButton, Typography } from "@mui/material";
import React from "react";
import {
    bgColor07,
  blackColor,
  blackShade05,
  blackShade159,
  blackShade19,
  blackShade23,
  greenColor2,
  greyColor060,
  greyColor13,
  greyColor9,
  mobilePrimary,
  orangeStatusColor,
  orderCardBorder,
  purpleColor01,
  redColor01,
  tamrindColor01,
  whiteColor,
} from "../../configs/styles/muiThemes";
import { getOrderDeliveryTypeText, getOrderType } from "../../utils/helper";
import { textOneLines } from "../../utils/styles";
import moment from "moment";
import LightToolTip from "../../components/Alerts/LightToolTip";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import ProductDetailsOrderReport from "./PopupCard/ProductDetailsOrderReport";

function OrderReportOrderDetailsCard({ item,index,toggleRow,setToggledIndex,toggledIndex,openRow,toggleBtn, getOndcBapNameBySubscriberId }) {
     const getTrackingStatus = (status) => {
        switch (status) {
          case "ordercreated":
            return "Created";
          case "orderapproved":
            return "Approved";
          case "ordershipped":
            return "Shipped";
          case "orderdelivered":
            return "Delivered";
          case "bordercanceled":
          case "cordercanceled":
          case "lordercanceled":
            return "Canceled";
    
          default:
            return "";
        }
      };
    
      const getStatusColor = (status) => {
        switch (status) {
          case "ordercreated":
            return purpleColor01;
          case "orderapproved":
            return orangeStatusColor;
          case "ordershipped":
            return tamrindColor01;
          case "orderdelivered":
            return greenColor2;
          case "bordercanceled":
          case "cordercanceled":
          case "lordercanceled":
            return redColor01;
    
          default:
            return blackShade05;
        }
      };
    
  return (
    <Box
      sx={{
        ...styles.card,
        backgroundColor:
          toggledIndex === index
            ? bgColor07
            : toggleBtn
            ? bgColor07
            : whiteColor,
      }}
    >
      <Grid container spacing={2}>
        <Grid item xs={6} md={1.5}>
          <Typography
            variant="h5"
            fontSize={12}
            fontWeight={600}
            color={blackShade19}
            lineHeight="23px"
          >
            # {item?.orderId}
          </Typography>
        </Grid>
        <Grid item xs={6} md={3}>
          <Box>
            <Typography
              sx={{
                color: getOrderType(item)?.color,
                fontSize: "12px",
                fontWeight: 600,
                lineHeight: "23px",
              }}
            >
              {getOrderType(item)?.label}{" "}
              {getOrderType(item)?.orderType === "ondcOrder" ? (
                <span style={{ color: blackShade19 }}>
                  {" "}
                  - {getOndcBapNameBySubscriberId(item?.ondcBapId)}
                </span>
              ) : null}
            </Typography>
            {getOrderType(item)?.orderType === "ondcOrder" && (
              <Typography
                variant="p"
                fontSize={12}
                fontWeight={600}
                color={getOrderType(item)?.color}
                lineHeight="23px"
                sx={{
                  ...textOneLines,
                  lineBreak: "anywhere",
                }}
              >
                # {item?.ondcOrderId}
                {/* {item?.ondcOrderId.length > 15
                                            ? `${item?.ondcOrderId.slice(0, 15)}. . .`
                                            : item?.ondcOrderId || ""} */}
              </Typography>
            )}
          </Box>
        </Grid>{" "}
        <Grid item xs={6} md={1.2}>
          <Typography
            variant="h5"
            fontSize={11.5}
            fontWeight={500}
            color={greyColor060}
            textAlign={"left"}
            lineHeight="20px"
          >
            {item?.orderCreatedOn
              ? moment(item?.orderCreatedOn).format("Do MMM, YYYY hh:mm A")
              : ""}
          </Typography>
        </Grid>
        <Grid item xs={6} md={1.8}>
          <LightToolTip title={item?.customerAddressName} placement="top">
            <Typography
              sx={{
                color: blackShade19,
                fontSize: "12px",
                fontWeight: 600,
              }}
              lineHeight="23px"
            >
              {item?.customerAddressName?.length > 15
                ? `${item?.customerAddressName.slice(0, 15)}. . .`
                : item?.customerAddressName}
            </Typography>
          </LightToolTip>
          <Typography
            variant="h5"
            fontSize={12}
            fontWeight={500}
            color={greyColor060}
            textAlign={"left"}
            lineHeight="23px"
          >
            {item?.customerAddressCity}
          </Typography>
        </Grid>
        <Grid item xs={12} md={1}>
          <Typography
            variant="h5"
            fontSize={12}
            fontWeight={600}
            color={blackShade19}
            textAlign={"left"}
            lineHeight="23px"
          >
            ₹ {item?.orderTotalCost}
          </Typography>
        </Grid>
        <Grid item xs={12} md={1.75}>
          <Typography
            variant="h5"
            fontSize={12}
            fontWeight={500}
            color={blackShade19}
            lineHeight="23px"
          >
            {getOrderDeliveryTypeText(
              item?.deliveryType?.type,
              item?.deliveryType?.shipType || ""
            )}
          </Typography>
        </Grid>
        <Grid item xs={12} md={1.75}>
          <Box
            display={"flex"}
            justifyContent={"space-between"}
            flexDirection={"row"}
            gap={1}
            alignItems={"center"}
            lineHeight={"23px"}
          >
            {item?.orderStatus && (
              <Box
                sx={{
                  height: "27px",
                  width: "82px",
                  display: "inline-flex",
                  alignItems: "center",
                  gap: "5px",
                  background: "#ffffff", // Background color
                  justifyContent: "center",
                  padding: "4px 8px",
                  borderRadius: "5px",
                  border: `1px solid  ${getStatusColor(item?.orderStatus)}`,
                }}
              >
                <Box
                  sx={{
                    background: getStatusColor(item?.orderStatus), // Orange background
                    width: "6px", // Width of the dot
                    height: "6px", // Height of the dot
                    borderRadius: "50px", // Makes it a circle
                    display: "inline-block", // Keeps it inline
                  }}
                />
                <Typography
                  variant="h5"
                  fontSize={11}
                  fontWeight={500}
                  color={getStatusColor(item?.orderStatus)}
                  lineHeight="23px"
                >
                  {getTrackingStatus(item?.orderStatus)}
                </Typography>
              </Box>
            )}
            <IconButton
              sx={styles.toggleBtn}
              variant="contained"
              disableElevation
              onClick={() => {
                toggleRow(item?.orderId);
                setToggledIndex(toggledIndex === index ? null : index);
              }}
            >
              {/* {backBtnText} */}
              {!toggledIndex || toggledIndex !== index ? (
                <KeyboardArrowDownIcon
                  sx={{ fontSize: "22px", color: greyColor060 }}
                />
              ) : (
                <KeyboardArrowUpIcon
                  sx={{ fontSize: "22px", color: greyColor060 }}
                />
              )}
            </IconButton>
          </Box>
        </Grid>
        {toggledIndex === index && (
          <Grid item md={12}>
            <ProductDetailsOrderReport item={item} openRow={openRow} />
          </Grid>
        )}
      </Grid>
    </Box>
  );
}

export default OrderReportOrderDetailsCard;

const styles = {
  card: {
    display: { md: "flex", xs: "none" },
    flexDirection: { xs: "column", md: "row" },
    gap: { xs: "16px", md: "20px" },
    backgroundColor: whiteColor,
    // backgroundColor: greyColor42,
    border: orderCardBorder,
    // borderRadius: "7px 7px 0px 0px",
    boxShadow: "0 2px 4px rgb(179 188 198 / 5%)",
    padding: "7px 15px",
    // position: "sticky",
    // top: 248,
    zIndex: 10000,
    // marginBottom: "15px",
  },
   backBtn: {
      width: "40px",
      height: "35px",
      backgroundColor: "#f1f4f7",
      padding: { md: "10px !important", xs: "3px 6px !important" },
      fontSize: "14px",
      color: { xs: mobilePrimary, md: blackShade159 },
      textTransform: "unset",
      textDecoration: "underline",
      border: {
        xs: "1px solid " + "#E4E7F4",
        md: "1px solid " + "#E4E7F4",
      },
      borderRadius: "10px",
      "&:hover": {
        backgroundColor: "transparent",
        color: { xs: mobilePrimary, md: greyColor13 },
      },
    },
    toggleBtn: {
      width: "32px",
      height: "32px",
      
      backgroundColor: whiteColor,
      padding: { md: "6px !important", xs: "3px 6px !important" },
      fontSize: "11px",
      color: { xs: mobilePrimary, md: greyColor060 },
      textTransform: "unset",
      textDecoration: "underline",
      border: {
        xs: "1px solid " + "#E4E7F4",
        md: "1px solid " + "#E4E7F4",
      },
      borderRadius: "50%",
      "&:hover": {
        backgroundColor: "transparent",
        color: { xs: mobilePrimary, md: greyColor060 },
      },
    },
    filterIconBtn: {
      height: "35px",
      padding: "4px 12px",
      fontSize: "11px",
      fontWeight: 600,
      color: "#3f454f",
      backgroundColor: whiteColor,
      border: "1px solid " + "#d4dae0",
      "&:hover": {
        color: whiteColor,
        backgroundColor: greyColor9,
      },
    },
};
